/*
 * @Description:
 * @Date: 2024-03-25 15:38:54
 */
import { onBeforeRouteLeave } from 'vue-router';
import { useKeepaliveStore } from '../store';

export const useKeepAlive = (needKeepAliveToNames: Array<string>) => {
  const { delKeepaliveName, addKeepaliveName } = useKeepaliveStore();
  onBeforeRouteLeave((to, from) => {
    if (typeof to.name === 'string' && needKeepAliveToNames.includes(to.name)) {
      typeof from.name === 'string' && addKeepaliveName(from.name);
    } else {
      typeof from.name === 'string' && delKeepaliveName(from.name);
    }
  });
};
